import { apiRequest } from './api-client'
import type { LoginResponse } from '@cgp/shared'

/**
 * Auth API surface. `apiRequest` already points at `${BASE_URL}/auth/*`
 * (VITE_API_BASE_URL or http://localhost:3000/v1) and emits an
 * Idempotency-Key for every POST, so a transient retry can never create a
 * second session.
 */
export const authApi = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const { data } = await apiRequest<LoginResponse>('/auth/login', {
      method: 'POST',
      body: { email, password },
    })
    return data as LoginResponse
  },

  /**
   * Best-effort logout. The worker revokes the refresh token + clears the
   * `cgp_rt` cookie; if the call fails (already logged out, 401, offline) we
   * swallow the error so the caller still clears local state and redirects.
   */
  async logout(): Promise<void> {
    try {
      await apiRequest('/auth/logout', { method: 'POST' })
    } catch (err) {
      if (import.meta.env.DEV) {
        console.warn('[authApi.logout] best-effort request failed:', err)
      }
    }
  },
}
